<template>
  <main-layout
    class="dataUplink"
    page-title="数据上链"
    custom-back
    @listen-back="goBack"
  >
    <div slot="main-content" class="main-content">
      <div class="img-list">
        <div
          class="img-item firstImg"
          v-if="isShowDataUplink"
          @click="goToUplinkForm"
        >
          <span class="img-item-text">数据上链配置</span>
        </div>
        <div class="img-item secondImg" @click="goToUplinkDataSheet">
          <span class="img-item-text">上链数据表</span>
        </div>
        <div class="img-item processImg" @click="goToStorage">
          <span class="img-item-text">仓储加工填报</span>
        </div>
        <div class="img-item eggImg" @click="goToStorageForEgg">
          <span class="img-item-text">加工填报</span>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import { windowHref } from "@/utils";
import { getShangHaiCertificateWhiteConfig } from "@/api/request/snkd.produce";

export default {
  name: "DataUplink",
  components: {
    MainLayout,
  },
  data() {
    return {
      isShowDataUplink: false,
    };
  },
  mounted() {
    this.fetchTechnicalAbriWhiteUrl();
  },
  methods: {
    async fetchTechnicalAbriWhiteUrl() {
      const { respCode, obj: result } =
        await getShangHaiCertificateWhiteConfig();
      if (respCode === 0) {
        this.isShowDataUplink = result.detailVOS[12]
          ? result.detailVOS[12].elements.indexOf(1) > -1
            ? true
            : false
          : false;
      }
    },
    goBack() {
      windowHref("/home/home");
    },
    goToUplinkDataSheet() {
      this.$router.push("/uplinkDataSheet");
    },
    goToUplinkForm() {
      // this.$router.push("/uplinkForm");
      this.$router.push("/uplinkList");
    },
    goToStorage() {
      this.$router.push("/storageProcess");
    },
    goToStorageForEgg() {
      this.$router.push("/storageProcessForEgg");
    },
  },
};
</script>

<style scoped lang="scss">
.dataUplink {
  .main-content {
    width: 1200px;
    height: 100%;
    background: #ffffff;
    margin: 0 auto;
    .img-list {
      justify-content: flex-start;
      display: flex;
      flex-wrap: wrap;
      padding-left: 30px;
      padding-top: 30px;
      .img-item {
        width: 200px;
        height: 200px;
        border-radius: 10px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        .img-item-text {
          color: #fff;
          font-family: OPPOSans;
          font-size: 24px;
          font-weight: 400;
        }
      }
      .firstImg {
        background: url("~@/assets/images/dataUplink/firstImg.png");
        background-size: cover;
        margin-right: 30px;
      }
      .secondImg {
        background: url("~@/assets/images/dataUplink/secondImg.png");
        background-size: cover;
        margin-right: 30px;
      }
      .processImg {
        background: url("~@/assets/images/dataUplink/process.png");
        background-size: cover;
        margin-right: 30px;
      }
      .eggImg {
        background: url("~@/assets/images/dataUplink/egg.png");
        background-size: cover;
        margin-right: 30px;
      }
    }
  }
}
</style>
